export const APP_NAME = 'Dealer Portal'

import { FileType } from '../types/fileUpload'

export const GOOGLE_MAPS_LIBRARIES: string[] = ['places']

export const booleanOptions = ['Yes', 'No']

export const requiredFieldsMap: Record<string, string[]> = {
  retail: [
    'dealerGroupNumber',
    'sku',
    'storeNumber',
    'invoiceTicketNumber',
    'retailProtectionPrice',
    'brand',
    'manufacturerModelNumber',
    'serial',
    'firstName',
    'lastName',
    'address1',
    'city',
    'state',
    'zip',
    'email',
    'phone',
    'planPurchaseDate',
  ],
  furniture: [
    'dealerGroupNumber',
    'sku',
    'storeNumber',
    'invoiceTicketNumber',
    'tax',
    'brand',
    'firstName',
    'lastName',
    'address1',
    'city',
    'state',
    'zip',
    'email',
    'phone',
    'planPurchaseDate',
    'productPurchaseDate',
    'onlinePurchase',
  ],
  oemw: [
    'dealerGroupNumber',
    'sku',
    'brand',
    'itemDescription',
    'manufacturerModelNumber',
    'country',
    'serial',
    'retailPrice',
  ],
  hvac: [
    'dealerGroupNumber',
    'sku',
    'storeNumber',
    'invoiceTicketNumber',
    // 'invoiceLineNumber',
    // 'itemDescription',
    'retailProtectionPrice',
    // 'manufacturerModelNumber',
    'serial',
    'brand',
    // 'invoiceDate',
    'firstName',
    'lastName',
    'address1',
    'city',
    'state',
    'zip',
    // 'country',
    'email',
    'phone',
    'planPurchaseDate',
  ],
  'home warranty': [
    'dealerGroupNumber',
    'sku',
    'storeNumber',
    // 'invoiceTicketNumber',
    'retailProtectionPrice',
    'firstName',
    'lastName',
    'address1',
    'city',
    'state',
    'zip',
    // 'country',
    'email',
    'phone',
    'planPurchaseDate',
  ],
  mobile: [
    'sku',
    'dealerGroupNumber',
    'sku',
    'storeNumber',
    'invoiceTicketNumber',
    'brand',
    'firstName',
    'lastName',
    'address1',
    'city',
    'state',
    'zip',
    'email',
    'phone',
    'planPurchaseDate',
    'retailProtectionPrice',
  ],
}

// ─── Visible fields per dealer type ──────────────────────────────────────────
export const fieldsToShow: Record<FileType, string[]> = {
  retail: [
    'dealerGroupNumber',
    'storeNumber',
    'invoiceTicketNumber',
    'invoiceDate',
    'retailProtectionPrice',
    'retailPrice',
    'tax',
    'itemDescription',
    'brand',
    'subCategory',
    'manufacturerModelNumber',
    'serial',
    'firstName',
    'lastName',
    'address1',
    'address2',
    'city',
    'state',
    'zip',
    'country',
    'email',
    'phone',
    'optInMobile',
    'optInEmail',
    'optInSms',
    'planPurchaseDate',
    'sku',
    'installationDate',
    'estimatedFirstDeliveryDate',
    'invoiceLineNumber',
    'salesPersonId',
  ],
  furniture: [
    'dealerGroupNumber',
    'storeNumber',
    'invoiceTicketNumber',
    'invoiceDate',
    'retailProtectionPrice',
    'protectionPlanType',
    'materialType',
    'tax',
    'totalInvoiceAmount',
    'invoiceLineNumber',
    'itemDescription',
    'quantity',
    'brand',
    'subCategory',
    'manufacturerModelNumber',
    'firstName',
    'lastName',
    'address1',
    'city',
    'state',
    'zip',
    'country',
    'email',
    'phone',
    'optInMobile',
    'optInEmail',
    'optInSms',
    'planPurchaseDate',
    'productPurchaseDate',
    'installationDate',
    'onlinePurchase',
    'deliveryDate',
    'sku',
    'serial',
  ],
  oemw: [
    'dealerGroupNumber',
    'itemDescription',
    'brand',
    'subCategory',
    'manufacturerModelNumber',
    'invoiceTicketNumber',
    'storeNumber',
    'serial',
    'sku',
    'retailPrice',
    'firstName',
    'lastName',
    'address1',
    'city',
    'state',
    'zip',
    'country',
    'email',
    'phone',
    'planPurchaseDate',
  ],
  hvac: [
    'dealerGroupNumber',
    'storeNumber',
    'invoiceTicketNumber',
    'invoiceLineNumber',
    'itemDescription',
    'brand',
    'subCategory',
    'quantity',
    'manufacturerModelNumber',
    'estimatedFirstDeliveryDate',
    'tax',
    'manufacturerModelNumber',
    'serial',
    'sku',
    'retailPrice',
    'retailProtectionPrice',
    'invoiceDate',
    'firstName',
    'lastName',
    'address1',
    'address2',
    'city',
    'state',
    'zip',
    'country',
    'email',
    'phone',
    'optInMobile',
    'optInEmail',
    'optInSms',
    'planPurchaseDate',
    'protectionPlanType',
    'installationDate',
    'salesPersonId',
    'oemWarrantyCertificate',
  ],
  'home warranty': [
    'dealerGroupNumber',
    'storeNumber',
    'sku',
    'tax',
    'firstName',
    'lastName',
    'address1',
    'address2',
    'city',
    'state',
    'zip',
    'country',
    'email',
    'phone',
    'optInMobile',
    'optInEmail',
    'optInSms',
    'squareFootage',
    'retailProtectionPrice',
    'homeClosingDate',
    'planPurchaseDate',
    'salesPersonId',
    'realtorFirstName',
    'realtorLastName',
    'realtorEmail',
    'loanNumber',
    'realtorId',
    'loanCompanyNumber',
    'uploadInspectionReport',
  ],
  mobile: [
    'dealerGroupNumber',
    'storeNumber',
    'invoiceTicketNumber',
    'invoiceDate',
    'retailPrice',
    'retialProtectionPrice',
    'itemDescription',
    'brand',
    'subCategory',
    'manufacturerModelNumber',
    'serial',
    'firstName',
    'lastName',
    'address1',
    'address2',
    'city',
    'state',
    'zip',
    'country',
    'email',
    'phone',
    'optInMobile',
    'optInEmail',
    'optInSms',
    'planPurchaseDate',
    'protectionPlanType',
    'retailProtectionPrice',
    'sku',
    'invoiceLineNumber',
  ],
}

export const defaultFieldsToShow: string[] = [
  'storeNumber',
  'invoiceTicketNumber',
  'invoiceDate',
  'invoiceLineNumber',
  'onlinePurchase',
  'rentToOwnPurchase',
  'quantity',
  'totalInvoiceAmount',
  'itemDescription',
  'brand',
  'subCategory',
  'manufacturerModelNumber',
  'serial',
  'retailPrice',
  'estimatedFirstDeliveryDate',
  'installationDate',
  'planPurchaseDate',
  'productPurchaseDate',
  'protectionPlanType',
  'materialType',
  'firstName',
  'lastName',
  'address1',
  'address2',
  'city',
  'state',
  'zip',
  'country',
  'email',
  'phone',
  'optInEmail',
  'optInMobile',
  'optInSms',
  'sku',
  'retailProtectionPrice',
  'tax',
  'squareFootage',
  'homeClosingDate',
  'salesPersonId',
  'realtorFirstName',
  'realtorLastName',
  'realtorEmail',
  'loanNumber',
]

export const defaultFieldLabels: Record<string, string> = {
  dealerGroupNumber: 'Dealer Group',
  storeNumber: 'Dealer ID / Store Number',
  invoiceTicketNumber: 'Invoice Ticket Number',
  invoiceDate: 'Invoice Date',
  invoiceLineNumber: 'Invoice Line Number',
  onlinePurchase: 'Online Purchase',
  rentToOwnPurchase: 'Rent To Own Purchase',
  quantity: 'Quantity',
  totalInvoiceAmount: 'Total Invoice Amount',
  itemDescription: 'Item Description',
  brand: 'Brand',
  subCategory: 'Sub Category',
  manufacturerModelNumber: 'Model Number',
  serial: 'Serial Number',
  retailPrice: 'Retail Price',
  estimatedFirstDeliveryDate: 'Delivery Date',
  installationDate: 'Installation Date',
  planPurchaseDate: 'Plan Purchase Date',
  protectionPlanType: 'Protection Plan Type',
  materialType: 'Material Type',
  firstName: 'First Name',
  lastName: 'Last Name',
  address1: 'Address',
  address2: 'Address 2',
  city: 'City',
  state: 'State',
  zip: 'Zip',
  country: 'Country',
  email: 'E-mail',
  phone: 'Mobile Phone',
  optInEmail: 'Email Opt In',
  optInMobile: 'Mobile Opt In',
  optInSms: 'Opt In SMS',
  sku: 'Contract SKU',
  retailProtectionPrice: 'Contract Purchase Price',
  tax: 'Contract Sales Tax',
  squareFootage: 'Square Footage',
  homeClosingDate: 'Home Closing Date',
  salesPersonId: 'Sales Person ID',
  realtorFirstName: 'Realtor First Name',
  realtorLastName: 'Realtor Last Name',
  realtorEmail: 'Realtor E-mail',
  loanNumber: 'Loan Number',
  oemWarrantyCertificate: 'OEM Certificate',
  uploadProofOfPurchase: 'Upload Proof Of Purchase',
  contractPurchaseDate: 'Contract Purchase Date',
}

export const fieldLabels: Record<string, Partial<Record<string, string>>> = {
  retail: {
    storeNumber: 'Store Number',
    planPurchaseDate: 'Product Purchase Date',
    retailProtectionPrice: 'Contract Purchase Price',
    tax: 'Sales Tax',
  },
  furniture: {
    storeNumber: 'Store Number',
    planPurchaseDate: 'Product Purchase Date',
    retailProtectionPrice: 'Protection Price',
    tax: 'Sales Tax',
    invoiceLineNumber: 'Invoice Line Number',
    contractPurchaseDate: 'Plan Purchase Date',
  },
  oemw: {
    storeNumber: 'Store Number',
    planPurchaseDate: 'Purchase Date',
    retailPrice: 'Product Retail Price',
  },
  hvac: {
    storeNumber: 'Dealer ID',
    planPurchaseDate: 'Purchase Date',
    installationDate: 'System Installation Date',
    retailProtectionPrice: 'Contract Price',
    tax: 'Tax Amount',
  },
  'home warranty': {
    storeNumber: 'Dealer ID',
    salesPersonId: 'Sales Person ID / Realtor / Loan Officer',
    planPurchaseDate: 'Plan Purchase Date',
    tax: 'Tax',
    sku: 'Plan SKU',
  },
  mobile: {
    storeNumber: 'Store Number',
    planPurchaseDate: 'Product Purchase Date',
    contractPurchaseDate: 'Plan Purchase Date',
  },
}

export const initialFormValues = {
  dealerGroupNumber: '',
  storeNumber: '',
  invoiceTicketNumber: '',
  invoiceDate: null as Date | null,
  onlinePurchase: '',
  retailProtectionPrice: '',
  totalRetailOfCoveredItems: '',
  totalInvoiceAmount: null as number | null,
  tax: null as number | null,
  quantity: null as number | null,
  estimatedFirstDeliveryDate: null as Date | null,
  productPurchaseDate: null as Date | null,
  rentToOwnPurchase: '',
  itemDescription: '',
  invoiceLineNumber: '1',
  manufacturer: '',
  brand: '',
  subCategory: '',
  manufacturerModelNumber: '',
  retailPrice: null as number | null,
  materialType: '',
  protectionPlanType: '',
  firstName: '',
  lastName: '',
  address1: '',
  address2: '',
  city: '',
  serial: '',
  country: 'US',
  state: '',
  zip: '',
  email: '',
  phone: '',
  optInMobile: 'Yes',
  optInEmail: 'Yes',
  optInSms: 'Yes',
  squareFootage: null as number | null,
  realtorProgram: '',
  oemWarrantyCertificate: '' as string | File,
  homeClosingDate: null as Date | null,
  installationDate: null as Date | null,
  planPurchaseDate: null as Date | null,
  uploadProofOfPurchase: '' as string | File,
  salesPersonId: '',
  sku: '',
  realtorFirstName: '',
  realtorLastName: '',
  realtorEmail: '',
  loanNumber: '',
}
